import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import { Component, ErrorInfo, ReactNode } from 'react';

import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import ApplicationStyleWrapper from '../ApplicationStyleWrapper/ApplicationStyleWrapper';

interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    };
    static propTypes: { children: PropTypes.Requireable<PropTypes.ReactNodeLike> };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        Sentry.captureException(error, {
            tags: { source: 'error_boundary' },
            extra: { componentStack: errorInfo.componentStack },
        });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <ApplicationStyleWrapper>
                    <ErrorPage />
                </ApplicationStyleWrapper>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node, // Validating children prop
};

export default ErrorBoundary;
